import { render } from "./LetterBox.vue?vue&type=template&id=408f1dc2&scoped=true"
import script from "./LetterBox.vue?vue&type=script&lang=js"
export * from "./LetterBox.vue?vue&type=script&lang=js"

import "./LetterBox.vue?vue&type=style&index=0&id=408f1dc2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-408f1dc2"

export default script